import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from '@app/shared/shared.module';
import { WizardModule } from '@app/ui/wizard/wizard.module';
import { WizardService } from '@app/ui/wizard/wizard.service';
import { TrackAndTraceModule } from '@smooved/ui';
import { TelecomInterestContainer } from './containers/telecom-interest/telecom-interest.container';
import { TelecomQualificationContainer } from './containers/telecom-qualification/telecom-qualification.container';
import { TelecomSuccessContainer } from './containers/telecom-success/telecom-success.container';
import { TotsProvidersModule } from './tots-providers.module';
import { TotsRoutingModule } from './tots-routing.module';
import { TotsWizardService } from './tots-wizard.service';

@NgModule({
    imports: [CommonModule, SharedModule, WizardModule, TotsProvidersModule, TotsRoutingModule, TrackAndTraceModule],
    declarations: [TelecomInterestContainer, TelecomQualificationContainer, TelecomSuccessContainer],
    providers: [{ provide: WizardService, useClass: TotsWizardService }],
})
export class TotsModule {}
